import { Button } from "@components/controls/Button"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link, useViewRoute } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Link Card",
  tags: ["cta-card"],
}

export default defineBlock("cta/cta-card", (props) => {
  const isAwardListing = !!useViewRoute("template-awards-listing")

  const Component = (props.link?.url ? Link : "div") as typeof Link

  return (
    <Component href={props.link?.url} target={props.link?.target!} className="bg-grey-light border-t px-4 pt-3 pb-4 text-black stack-y-6 justify-between w-full">
      <div className="stack-y-2 text-balance">
        <EditableText store="heading" as="div" className="type-ui-s-roman-caps" placeholder="Heading" />
        <EditableText store="title" as="div" className="type-title-s-medium" defaultValue={props.link?.title ?? "No link selected"} />
      </div>
      {!isAwardListing && (
        <div>
          <Button variant="charcoal">
            <EditableText store="button" defaultValue="Read More" />
          </Button>
        </div>
      )}
    </Component>
  )
})
